/**
 * Owner: Masa Bayu
 * File: color-role.ts
 * Date:Time: 2026-09-13 21:16
 * Description: 22C semantic color roles and theme role→swatch mappings.
 */
export const QX_COLOR_ROLES = [
    'background',
    'surface',
    'surface-elevated',
    'foreground',
    'foreground-muted',
    'primary',
    'secondary',
    'accent',
    'border',
    'divider',
    'success',
    'warning',
    'danger',
];
const FORBIDDEN = [
    'css',
    'hex',
    'rgb',
    'hsl',
    'gradient',
    'opacity',
    'shadow',
    'className',
    'style',
    'dom',
];
function assertNoForbidden(record, label) {
    for (const key of FORBIDDEN) {
        if (key in record) {
            throw new Error(`${label} must not include render field "${key}"`);
        }
    }
}
function assertId(value, label) {
    if (typeof value !== 'string' || value.trim().length === 0 || /\s/.test(value)) {
        throw new Error(`${label} must be a non-empty id without whitespace`);
    }
}
export function isQXColorRole(value) {
    return typeof value === 'string' && QX_COLOR_ROLES.includes(value);
}
export function createQXThemeColorMapping(role, swatchId) {
    assertNoForbidden({ role, swatchId }, 'Theme color mapping');
    if (!isQXColorRole(role)) {
        throw new Error(`Invalid color role: ${String(role)}`);
    }
    assertId(swatchId, 'Theme color mapping swatchId');
    return Object.freeze({ role, swatchId: swatchId.trim() });
}
//# sourceMappingURL=color-role.js.map